import type { SxProps, Theme } from "@mui/material";

/** Shared paper styles for mobile bottom sheets (dialogs, menus). */
export const bottomSheetPaperSx: SxProps<Theme> = {
    width: "100%",
    maxWidth: "100%",
    maxHeight: "90vh",
    boxSizing: "border-box",
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    overflow: "hidden",
    bgcolor: "background.paper",
    display: "flex",
    flexDirection: "column",
};

export const bottomSheetHandleSx: SxProps<Theme> = {
    display: "flex",
    justifyContent: "center",
    flexShrink: 0,
    py: 1,
};

export const bottomSheetHandlePillSx: SxProps<Theme> = {
    width: 36,
    height: 4,
    borderRadius: 2,
    bgcolor: "text.disabled",
};

export const bottomSheetContentSx: SxProps<Theme> = {
    flex: 1,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
};
